// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nvKm","col":"styles_col__SU6S7"};